import { ADD_FEATURE_FLAGS } from './constants';

export const addFeatureFlags = (featureFlags) => ({
    type: ADD_FEATURE_FLAGS,
    featureFlags,
});
